import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { CrudService } from "src/app/services/crud.service";
import { UtilService } from "src/app/services/util.service";
import { AuthService } from "src/app/services/auth.service";
import { loadingProps } from "src/utils/util.functions";
import { Platform, NavController, LoadingController } from "@ionic/angular";

@Component({
    selector: "app-form-trip",
    templateUrl: "./form-trip.page.html",
    styleUrls: ["./form-trip.page.scss"],
    providers: [],
    standalone: false
})
export class FormTripPage implements OnInit, OnDestroy {
  form: UntypedFormGroup;
  sub: Subscription;
  id: string;
  title = "";
  isQrCode = false;
  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private crud: CrudService,
    private util: UtilService,
    private auth: AuthService,
    private platform: Platform,
    public navCtrl: NavController,
    public loadingController: LoadingController,
  ) {
  }
//http://localhost:8100/form-restaurant/B8IMN37DR3?qrCode=true
  async ngOnInit() {
    this.form = this.fb.group({
      nomeCliente: ["", Validators.required],
      celular: ["", Validators.required],
      linkUrl: [`https://www.gospread.online${this.router.url}`],
    });
    await this.showLoading();
    this.sub = this.route.params.subscribe((data) => {
      this.title = this.router.url.includes('form-restaurant') ? "Establishment Access" : "Trip Access";
      if (data) {
        this.route.queryParams.subscribe(async (params) => {
          if (params && params.qrCode) {
            this.isQrCode = params.qrCode;          
            if (this.isQrCode) {     
              this.crud.postData("link/qr-code/validate", null, this.form.value).subscribe(
                async (response: any) => {
                  if (!response.success) {
                    await this.loadingController.dismiss();
                    this.util.showToast(response.errors[0]);
                  } else {                   
                    await this.auth.saveAuth({
                      token: response["data"].token,
                      userType: response["data"].userType
                    });
                    localStorage.setItem("callerId", response["data"].callerId);
                    sessionStorage.setItem("dataClient", JSON.stringify(this.form.value));
                    this.util.showToast("Welcome");
                    await this.loadingController.dismiss();
                    this.router.navigate([
                      "call",
                      "restaurants-booking",
                      response["data"].callerId,
                      true
                    ], { skipLocationChange: true });
                  }
                },
                async (error) => {
                  this.util.showToast(error.errors[0]);
                  await this.loadingController.dismiss();
                }
              );
            }
            else {
              await this.loadingController.dismiss();
            }
          }
          else {
            await this.loadingController.dismiss();
          }
        });
      }
    });
  }

  async requestTrip() {
    await this.showLoading();
    this.crud.postData("link/validate", null, this.form.value).subscribe(
      async (response: any) => {
        if (!response.success) {
          await this.loadingController.dismiss();
          this.util.showToast(response.errors[0]);
        } else {         
          await this.auth.saveAuth({
            token: response["data"].token,
            userType: response["data"].userType
          });
          localStorage.setItem("callerId", response["data"].callerId);
          sessionStorage.setItem("dataClient", JSON.stringify(this.form.value));
          this.util.showToast("Welcome");
          if (this.router.url.includes('form-restaurant')) {
            await this.loadingController.dismiss();
            this.router.navigate([
              "call",
              "restaurants-booking",
              response["data"].callerId,
            ]);
          }
          else {
            await this.loadingController.dismiss();
            this.router.navigate([
              "call",
              "call-driver",
              response["data"].callerId,
            ]);
          }
        }
      },
      async (error) => {
        this.util.showToast(error.errors[0]);
        await this.loadingController.dismiss();
      }
    );
  }
  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadingController.create(loadingProps);
    return await loading.present();
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
